import { render, staticRenderFns } from "./BillsOfLandingTabla.vue?vue&type=template&id=b05fb6ce"
import script from "./BillsOfLandingTabla.vue?vue&type=script&lang=js"
export * from "./BillsOfLandingTabla.vue?vue&type=script&lang=js"
import style0 from "./BillsOfLandingTabla.vue?vue&type=style&index=0&id=b05fb6ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports